module.exports = __webpack_public_path__ + "img/health-guide-noise.c70ca11c.png";